<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("grn") }}</div>
        <div class="section-subTitle my-2"
          >{{ $tc("listofall") }} {{ $t("grn") }}</div
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table text-center" v-if="listView">
      <thead>
        <tr>
          <th class="text-left">{{ $t("grn") }} {{ $t("no") }}</th>
          <th class="text-left">{{ $t("ponumber") }}</th>
          <th class="text-left">{{ $t("invoice") }} {{ $t("number") }}</th>
          <th class="text-left">{{ $tc("rawmaterials", 2) }}</th>
          <th class="text-left">{{ $t("received") }}</th>
          <!-- <th class="text-left">{{ $t('uom') }}</th> -->
          <th class="text-left">{{ $t("invoice") }} {{ $t("date") }}</th>
          <th class="text-left"
            >{{ $tc("transferred", 2) }} {{ $t("stock") }} {{ $t("date") }}</th
          >
          <th class="text-left">{{ $tc("Remark") }}</th>
          <!-- <th>{{ $tc('transferred', 2) }} {{ $t('stock') }} {{ $t('expiry') }} {{ $t('date') }}</th> -->
          <th>{{ $t("download") }} as:</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(singleGrn, singleGrnIndex) in grnList"
          :key="singleGrnIndex"
        >
          <td class="text-left">{{ singleGrn.stock_in_id }}</td>
          <td class="text-left">{{ singleGrn.po_number }}</td>
          <td class="text-left">{{ singleGrn.invoice_number }}</td>
          <td class="text-left">{{ singleGrn.rm_name }}</td>
          <td class="text-left"
            >{{ singleGrn.stock_in_quantity }} &nbsp;{{
              singleGrn.uom_short_form
            }}</td
          >
          <!-- <td class="text-left">{{ singleGrn.uom_short_form }}</td> -->
          <td class="text-left">{{ singleGrn.invoice_date | dateparse }}</td>
          <td class="text-left">{{ singleGrn.stock_in_date | dateparse }}</td>
          <!-- <td>{{ singleGrn.stock_in_expiry_date | dateparse }}</td> -->
          <td class="text-center">
            <div style="white-space:break-spaces;word-break: break-all;">
              {{ singleGrn.grn_remark || "-" }}
            </div>
          </td>
          <td>
            <a
              :href="BASE_URL + singleGrn.FinalPDFFile"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      v-if="grnList && grnList.length > 0"
      class="d-flex justify-content-end mt-3 align-items-center"
    >
      <div>{{ $t("download") }}&nbsp;All:&nbsp;</div>
      <a
        target="_blank"
        @click="getGrnAllPdf()"
        title="Download as PDF"
        download
      >
        <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
      </a>
    </div>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
  import PosFnbService from "@/services/PosFnbService";

  export default {
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",

        submitted: false,
        gridView: false,
        listView: true,
        grnList: [],

        po_id: null,
        rm_id: null,
        cinema_id: null,
        grnPDF: null,
        grnPDFAll: null,
        rm_ids: [],
      };
    },

    mounted() {
      this.getGrnList();
    },
    beforeMount() {
      this.po_id = this.$route.query.po_id;
      this.rm_id = this.$route.query.rm_id;
      this.cinema_id = this.$route.query.cinema_id;
      this.getviewingnumber();

      this.rm_ids =
        typeof this.$route.query.rm_ids == "string"
          ? [this.$route.query.rm_ids]
          : this.$route.query.rm_ids;
    },
    methods: {
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          this.selectedvalue = event;
          this.perPage = event;
          this.onChangePagination();
        }
      },
      /* eslint-disable */
      onChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.getGrnList();
        } else {
          this.currentPage = event;
          this.getGrnList();
        }
      },

      viewType: function(viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },
      getGrnAllPdf: function() {
        let loader = this.$loading.show();
        let payload = {
          limit: this.rows,
          currentPage: this.currentPage,
          po_id: this.po_id,
          rm_id: this.rm_id,
          cinema_id: this.cinema_id,
          skip_rm_id: this.rm_ids && this.rm_ids.length > 1,
        };
        PosFnbService.GetGrnList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.FinalPDFFile) {
                window.open(this.BASE_URL + data.FinalPDFFile, "_blank");
                loader.hide();
              }
            } else {
              this.$toasted.show(data.message);
              loader.hide();
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
      getGrnList: function() {
        let loader = this.$loading.show();
        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
          po_id: this.po_id,
          rm_id: this.rm_id,
          cinema_id: this.cinema_id,
          skip_rm_id: this.rm_ids && this.rm_ids.length > 1,
        };
        PosFnbService.GetGrnList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records && data.Records.length > 0) {
                this.grnList = data.Records;
                this.grnPDF = data.FinalPDFFile;
                if (data.totalRows >= 10) {
                  this.rows = data.totalRows;
                } else {
                  this.rows = data.totalRows;
                  this.selectedvalue = data.totalRows;
                }
                loader.hide();
              }
            } else {
              this.$toasted.show(data.message);
              loader.hide();
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/StockComponents/viewGrn.vue